import { DollarCircleFilled, PoundCircleFilled, EyeFilled } from "@ant-design/icons";
import { Button, Card, DatePicker, Radio, Table, Tooltip } from "antd";
import React, { useEffect } from "react";
import { CSVLink } from "react-csv";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

import dayjs from "dayjs";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { addPayslipPayment } from "../../redux/rtk/features/payment/paymentSlice";
import {
  loadAllPayslipForPayment,
  loadAllPayslipForPaymentMonthWise,
} from "../../redux/rtk/features/payroll/payrollSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import PageTitle from "../page-header/PageHeader";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import { VioletLinkBtn } from "../UI/AllLinkBtn";
import BtnSearchSvg from "../UI/Button/btnSearchSvg";

function CustomTable({ list, loading, month, year, paymentStatus }) {
  const [columnsToShow, setColumnsToShow] = useState([]);
  const currentUser = getUserFromToken();
  // const userPayslips = list.filter((item) => item.userId === currentUser);
  const userPayslips = list?.filter((item) => item.userId === currentUser) || [];

  const roleId = parseInt(localStorage.getItem("roleId"), 10);

  console.log("CurrentUserId", currentUser);

  const dispatch = useDispatch();
  // const loadingButton = useSelector((state) => state.payment.loading);
  const [loadingButton, setLoadingButton] = useState(false);

  const columns = [
    {
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      title: "Name",
      key: "name",
      dataIndex: "user",
      render: (user) => `${user?.firstName} ${user?.lastName}`,
    },

    {
      title: "Salary",
      dataIndex: "salary",
      key: "salary",
    },
    {
      title: "Salary Payable",
      dataIndex: "salaryPayable",
      key: "salaryPayable",
    },
    {
      title: "Month ",
      key: "month",
      render: ({ salaryMonth }) => {
        const formattedMonth = dayjs(String(salaryMonth), "M").format("MMM");
        return formattedMonth;
      },
    },
    {
      title: "Year",
      key: "year",
      render: ({ salaryYear }) => `${salaryYear}`,
    },

    {
      title: "bonus",
      dataIndex: "bonus",
      key: "bonus",
    },

    {
      title: "bonusComment",
      dataIndex: "bonusComment",
      key: "bonusComment",
    },

    {
      title: "deduction",
      dataIndex: "deduction",
      key: "deduction",
    },

    {
      title: "deductionComment",
      dataIndex: "deductionComment",
      key: "deductionComment",
    },

    {
      title: "Total",
      dataIndex: "totalPayable",
      key: "totalPayable",
    },

    {
      title: "W Hours",
      dataIndex: "workingHour",
      key: "workingHour",
      render: (workingHour) => `${workingHour?.toFixed(2)} hours`,
    },
    {
      title: "Status",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
    },
    {
      title: "Action",
      key: "action",
      render: ({ id, paymentStatus }) => {
        const onPayment = async () => {
          setLoadingButton(true);
          const resp = await dispatch(addPayslipPayment(id));
          if (resp.meta.requestStatus === "fulfilled") {
            setLoadingButton(false);
            dispatch(
              loadAllPayslipForPaymentMonthWise({
                month,
                year,
                status: paymentStatus,
              })
            );
          }
        };

        return (
          <div flex justify-between>
            <Link to={`/admin/payroll/${id}`}>
              <Tooltip title="View">
                <Button
                  icon={<EyeFilled />}
                  type="primary"
                  size="middle"
                  className="mr-2"
                ></Button>
              </Tooltip>
            </Link>

            <UserPrivateComponent permission="create-transaction">
              <Tooltip title="Payment">
                <Button
                  loading={loadingButton[id]}
                  icon={<PoundCircleFilled />}
                  type="primary"
                  size="middle"
                  onClick={onPayment}
                  disabled={paymentStatus === "PAID"}
                ></Button>
              </Tooltip>
            </UserPrivateComponent>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  // const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
  const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


  return (
    <div className="mt-5">
      <div className="text-center my-2 flex justify-between">
        {list && (
          <div style={{ marginBottom: "30px" }}>
            <ColVisibilityDropdown
              options={columns}
              columns={columns}
              columnsToShowHandler={columnsToShowHandler}
            />
          </div>
        )}

        {list && (
          <div>
            <CsvLinkBtn>
              <CSVLink
                data={list}
                className="btn btn-dark btn-sm mb-1"
                filename="payslips"
              >
                Download CSV
              </CSVLink>
            </CsvLinkBtn>
          </div>
        )}
      </div>

      <Table
        scroll={{ x: true }}
        loading={loading || loadingButton}
        columns={columnsToShow}
        // dataSource={list ? addKeys(list) : []} // use this line if you want to show all users' payslip
        // dataSource={userPayslips ? addKeys(userPayslips) : []} // use this line if wants to show only logged in user's payslip
        dataSource={
          roleId === 1
            ? addKeys(list)
            : userPayslips
            ? addKeys(userPayslips)
            : []
        } 
        // use this line to show all data to roleId =1 and selected data to other user
        // pagination ={false}
      />
    </div>
  );
}

const PayslipList = () => {
  const [month, setMonth] = useState(dayjs().format("M"));
  const [year, setYear] = useState(dayjs().format("YYYY"));
  const [paymentStatus, setPaymentStatus] = useState("ALL");

  // const payroll = useSelector((state) => state.payroll.list);
  const payroll = useSelector((state) => state.payroll.list || []); // Ensure list is never undefined

  const loading = useSelector((state) => state.payroll.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadAllPayslipForPayment());
  }, []);

  // TODO: Update ONCHANGEs function

  // const onMonthChange = (date, dateString) => {
  //   setMonth(dateString);
  //   // dispatch(loadAllPayslipForPayment({ month: dateString, year }));
  // };

  // const onYearChange = (date, dateString) => {
  //   setYear(dateString);
  // };

  const onMonthChange = (date, dateString) => {
    if (date) {
      setMonth(date.format("M")); // Month as a number
    }
  };
  
  const onYearChange = (date, dateString) => {
    if (date) {
      setYear(date.format("YYYY")); // Year
    }
  };
  

  const options = [
    {
      label: "ALL",
      value: "ALL",
    },
    {
      label: "PAID",
      value: "PAID",
    },
    {
      label: "UNPAID",
      value: "UNPAID",
    },
  ];

  const onChange4 = ({ target: { value } }) => {
    setPaymentStatus(value);
  };

  const onClickSearch = () => {
    if (paymentStatus === "ALL") {
      dispatch(loadAllPayslipForPayment({ month, year }));
    } else {
      dispatch(
        loadAllPayslipForPaymentMonthWise({
          month,
          year,
          status: paymentStatus,
        })
      );
    }
  };

  return (
    <div>
      <PageTitle title="Back" />
      <UserPrivateComponent permission="readAll-payroll">
        <Card className="mt-5">
          <div className="flex justify-end">
            <h1 className="text-base text-color-2 items-center mr-2 mt-1">
              {" "}
              Select Month :{" "}
            </h1>
            <DatePicker
              format={"MMM"}
              className=" mr-5"
              style={{ maxWidth: "200px" }}
              picker="month"
              // defaultValue={dayjs()}
              onChange={onMonthChange}
            />
            <h1 className="text-base text-color-2 items-center mr-2 mt-1">
              {" "}
              Select Year :{" "}
            </h1>
            <DatePicker
              format={"YYYY"}
              picker="year"
              style={{ maxWidth: "200px" }}
              onChange={onYearChange}
              // defaultValue={dayjs()}
            />
            <Radio.Group
              className="ml-3 mr-3"
              options={options}
              onChange={onChange4}
              value={paymentStatus}
              optionType="button"
              buttonStyle="solid"
            />
            <VioletLinkBtn>
              <button onClick={onClickSearch}>
                <BtnSearchSvg size={25} title={"SEARCH"} loading={loading} />
              </button>
            </VioletLinkBtn>
          </div>

          <CustomTable
            list={payroll}
            loading={loading}
            month={month}
            year={year}
            paymentStatus={paymentStatus}
          />
        </Card>
      </UserPrivateComponent>
    </div>
  );
};

export default PayslipList;
